import {Component, OnInit} from '@angular/core';
import { SystemAdminService } from '../../admin/system-admin.service';

@Component({
  selector: 'iaud-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

  showSysAdmin: boolean = false;
  showAudit: boolean = false;
  showSid: boolean = false;

  constructor(private sysadmSvc: SystemAdminService) { }

  ngOnInit(): void {
    this.sysadmSvc.showAdminMenu()
      .subscribe(x => this.showSysAdmin = x);

      this.sysadmSvc.showAuditMenu()
      .subscribe(x => this.showAudit = x);

      this.sysadmSvc.showSidMenu()
      .subscribe(x => this.showSid = x);
  }

}
